<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户ID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入用户ID">
						</el-input>
					</el-form-item>
                    <el-form-item label="收支" class='tiny '>
						<el-select v-model="searchInfo.changeType" placeholder="请选择" clear>
							<el-option key="9" label="全部" value="">全部</el-option>
							<el-option key="-1" label="减少" value="-1"></el-option>
							<el-option key="1" label="增加" value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="变动时间">
						<div class="block">
							<el-date-picker v-model="timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button>
							</el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="withdrawal.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" >
			<el-table-column prop="" label="用户" align="center" :show-overflow-tooltip="true" min-width="150">
                <template slot-scope="scope">
					<span >{{scope.row.userId}}</span>
					<span v-if="scope.row.username">~ {{scope.row.username}}</span>
					<span v-if="scope.row.phone">~ {{scope.row.phone}}</span>
				</template>
			</el-table-column>
            <el-table-column prop="creditScoreBefore" label="变动前信用分" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
            <el-table-column prop="" label="收支" align="center" :show-overflow-tooltip="true" >
                <template slot-scope="scope">
					<div v-if="scope.row.changeType==-1">减少</div>
					<div v-if="scope.row.changeType==1">增加</div>
				</template>
			</el-table-column>
			<el-table-column prop="typeName" label="变动类型" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
            <el-table-column prop="creditNum" label="变动数量" align="center" :show-overflow-tooltip="true">
			</el-table-column>
            
			<el-table-column prop="memo" label="备注" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
			<el-table-column prop="createDate" label="变动时间" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
			
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="withdrawal.pageNum" @current-change="pageChange"
			layout="total, sizes, prev, pager, next, jumper" :total="withdrawal.total" @size-change="handleSizeChange">
		</el-pagination>

		
		<!-- 审核 -->
		<el-dialog style="float:rigin" :title="title" :visible.sync="queryDialogVisible" width="50%"
			:close-on-click-modal="false">
		
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
		
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="用户:" class="redItem" style="width: 50%;">
							<span >{{payment.userId}}</span>
                            <span v-if="payment.username">~ {{payment.username}}</span>
                            <span v-if="payment.phone">~ {{payment.phone}}</span>
						</el-form-item>
					
						<el-form-item label="信用分:" class="redItem" style="width: 50%;">
							{{payment.creditScore}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="类型:" class="redItem" style="width: 50%;">
							<div v-if="payment.type==0">贡献质押</div>
					        <div v-if="payment.type==1">流动性供应</div>
						</el-form-item>
					
						<el-form-item label="期限:" class="redItem" style="width: 50%;">
							{{payment.typeName}}
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
                        <el-form-item label="资产:" class="redItem" style="width: 50%;">
							<div v-if="payment.type==0">DWQ</div>
                            <div v-if="payment.type==1">Cash</div>
						</el-form-item>

                        <el-form-item label="数量:" class="redItem" style="width: 50%;">
							{{payment.integralNum}}
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
                <el-button  @click="queryDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">通 过</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	
	export default {
		data() {
			return {
				applyDatil: false, //申请提现弹窗
				dialogDatil: false,
				// 搜索部分
				integralWithdrawal:{},
				showContentDialog:false,
				payId:'',
				reason:'',
				searchInfo: {
					changeType: ''
				},
				loading: false,
				queryDialogVisible:false,
				withdrawal: {},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				payment: {},
				bhLoading:false,
				type:'',
				storeInfo: {},
				amount: '',
				contentValue:'',
				contentValueArr:[],
				limtInfo: {},
				count: 60,
				title:'',
                flag: true,
                
                timer: []
			}
		},
		methods: {
			showContent(content) {
				this.contentValue = ''
				this.contentValueArr = []
				this.contentValue = content
				this.contentValueArr = this.contentValue.split(',')
				this.showContentDialog = true
			},
			remit() {
				this.$api.haveMoneyUpOrStartUsing(this.$encrypt(this.payment)).then((res) => {
					// console.log('res', res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.queryDialogVisible = false;
						this.getCreditList();
					} else {
						this.$message.error(res.message);
					}
				})
			},
			
			//上传logo
			upLoadLogo(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					console.log('列表:', res);
					this.payment.systemDocuments = res.message
				})
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				};
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			// 查询
			search() {
				this.page.pageNum = 1;
				this.getCreditList()
			},
			// 清空
			empty() {
                this.timer = []
				this.searchInfo = {}
			},
			//导出
			downloadFile() {

			},
			reject(){
				this.bhLoading = true;
				// console.log(scope.row.id);
				
				this.$api.shenhePass(this.$encrypt({
					reason:this.reason,
					id:this.payId,
					status:4
				})).then((res) => {
				// 	console.log('res', res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.bhLoading = false;
						this.reason=''
						this.queryDialogVisible = false
						this.getCreditList()
					} else {
						this.reason=''
						this.$message.error(res.message);
					}
				})
			},
			// 通过
			confirm(){
				this.$api.auditCreditByID(this.payId).then(res=>{
					if(res.state == 'success'){
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.queryDialogVisible = false
						this.getCreditList()
					}
				})
			},
			//申请提现
			applyWithdrawal() {
				this.applyDatil = true
				this.$api.byKey({
					key: 'Store_Withdrawal_Parameter'
				}).then(res => {
					res = JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						this.limtInfo = JSON.parse(res.data.settingValue)
						console.log(this.limtInfo);
					}
				})
				this.$api.getUserInfo(this.$encrypt({})).then(res => {
					res.data = JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.storeInfo = res.data.store
						console.log(this.storeInfo);
					}
				})
			},
			// 商户撤销
			revoke(id) {
				console.log(id);
				this.$confirm('是否撤销该次提现?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(2222);
					this.$api.storeRovek(id).then(res => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getCreditList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					// console.log(3333);
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			queryIntegralWithdrawal(item,type,title) {
				this.title = title
				// console.log(title);
				this.type=type
				this.payId = item.id
				
				this.payment = item
			
				this.queryDialogVisible=true
				
			},
			code() {
				this.timeDown()
				this.$api.captCode({
					phone: this.storeInfo.phone,
					type: "register"
				}).then(res => {
					console.log(res);
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
					}
				})
			},
			// 验证码倒计时
			timeDown() {
				this.count--;
				this.flag = false;
				var timer = setInterval(() => {
					if (this.count > 0) {
						this.count--;
						this.flag = false
					} else {
						clearInterval(timer)
						timer = null;
						this.count = 60;
						this.flag = true
					}
				}, 1000)
			},
			// 确认提交按钮
			sure() {

			},

			pageChange(data) {
				this.page.pageNum = data
				this.getCreditList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getCreditList()
			},
			//编辑弹框
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			getCreditList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					startTime: this.timer ? this.timer[0] : "",
					endTime: this.timer ? this.timer[1] : "",
					...this.searchInfo
                }
                // this.$encrypt(data)
				this.$api.CreditScoreList(data).then(res => {
					// res = JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
						console.log('变动记录---',res);
						this.withdrawal = res.data
						this.loading = false
					}
				})
			}
		},
		created() {
			this.getCreditList()
		}
	}
</script>

<style scoped lang="less">
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}

	/deep/.el-input__inner {
		color: black !important;
	}

	/deep/.el-textarea__inner {
		color: black !important;
	}
</style>